import Icon from '../components/Icon';

const Message = Icon(
  'message',
  <>
    <path d="M8.25 10.5A.75.75 0 0 1 9 9.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M8.25 13.5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75" />
    <path
      fillRule="evenodd"
      d="M12.637 2.273a9.75 9.75 0 0 0-9.24 14.312l-1.069 3.189a1.503 1.503 0 0 0 1.078 1.935 1.5 1.5 0 0 0 .82-.037l3.192-1.065a9.75 9.75 0 1 0 5.219-18.334M6.976 5.459a8.25 8.25 0 1 1 .893 13.683.75.75 0 0 0-.613-.062l-3.505 1.169 1.172-3.5a.75.75 0 0 0-.062-.614A8.25 8.25 0 0 1 6.976 5.458"
      clipRule="evenodd"
    />
  </>
);

export default Message;
